export  const Divider = () => (
    <div className="my-10 border-t border-base-200"></div>
  );
  
